import { getNumberId } from "../models/common/Identifier";

export function changeReduxArrayItemState< T, R extends keyof T >(
    haystack: T[],
    needleId: number,
    needlePropName: R,
    newState: Partial< T >
): T[]
{
    return haystack.map( ( obj: T ) => {
        if( getNumberId( obj[ needlePropName ] ) === needleId ) {
            return {...obj, ...newState};
        } else {
            return obj;
        }
    } );
}
